import { baseEnvironment } from 'src/environments/baseEnvironment.preprod';

export const environment = {
  ...baseEnvironment,
  optioningApplicationSmartGroupUrl:'https://optioning.datalean-nodejs-preprod.catalean.com/optioning/user/applicationSmartGroup',
  optioningApplicationGroupUrl:'https://optioning.datalean-nodejs-preprod.catalean.com/optioning/user/applicationGroup',
  customProductImportUrl:'https://optioning.datalean-nodejs-preprod.catalean.com/custom-import/xlsx',
  organizationPrefix: 'SEL',
  organizationUUID: 'e94e3b87-e284-47cf-9b25-fbc34e33e86e',
  activeLanguage: 'it-IT',
  multipleAdminCommunity: true,
  requiredField: {
  },
  systemToken: '',
  htmlFields: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ header: 1 }, { header: 2 }],
    ['blockquote'],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub'}, { script: 'super' }, 'link'],
    [{ list: 'ordered'}, { list: 'bullet' }, { align: [] }],
    ['clean']
  ],

  basicConfiguration: {
    htmlEditorMaxLength: {
      active: false,
      where: [
        {
          name: 'product',
          value: 270
        }
      ]
    }
  },
  googleAPIKey: '',
  manageTemplates: false,
  manageUserFilter: false,

  productEditorTabIcons: [
    'r',
    'z',
    'M',
    'x',
    'm'
  ],
  pwaThemeColor: 'rgba(0, 72, 205, 1.0)'
};
